import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import batchService from '../services/batchService';
import productService from '../services/productService';
import BatchForm from '../components/BatchForm';
import '../styles/batches.css';

const CreateBatchPage = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadProducts = async () => {
      setLoadingProducts(true);
      setError('');

      try {
        const result = await productService.getProducts({
          page: 1,
          limit: 100,
          is_active: true,
        });

        if (!cancelled) {
          setProducts(result.products || []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(
            err.response?.data?.message ||
              'Unable to load active products.'
          );
        }
      } finally {
        if (!cancelled) {
          setLoadingProducts(false);
        }
      }
    };

    loadProducts();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleSubmit = async (batchData) => {
    setSaving(true);
    setError('');

    try {
      await batchService.createBatch(batchData);

      navigate('/user/batches', {
        replace: true,
        state: {
          notice: 'Batch created successfully. Stock has been updated.',
        },
      });
    } catch (err) {
      const responseErrors = err.response?.data?.errors;

      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        setError(
          responseErrors
            .map((item) => item.message)
            .filter(Boolean)
            .join(' ')
        );
      } else {
        setError(
          err.response?.data?.message ||
            'Unable to create batch. Please try again.'
        );
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="batches-page create-batch-page">
      <div className="batches-page-header">
        <div>
          <Link to="/user/batches" className="batch-back-link">
            ← Back to Batches
          </Link>

          <h1>Add Batch</h1>
          <p>
            Record a product batch, its received quantity, pricing, and
            expiry information.
          </p>
        </div>
      </div>

      {error && (
        <div className="batch-alert batch-alert-error" role="alert">
          {error}
        </div>
      )}

      {loadingProducts ? (
        <div className="batches-table-state" role="status">
          Loading active products...
        </div>
      ) : products.length === 0 ? (
        <div className="batch-empty-products">
          <h2>No active products available</h2>
          <p>
            Create a product or activate an existing product before
            recording a batch.
          </p>

          <Link
            to="/user/products/create"
            className="batch-primary-button"
          >
            + Add Product
          </Link>
        </div>
      ) : (
        <div className="batch-form-card">
          <BatchForm
            products={products}
            onSubmit={handleSubmit}
            submitLabel="Create Batch"
            loading={saving}
          />
        </div>
      )}
    </section>
  );
};

export default CreateBatchPage;